// For Demo denisso.github.io
export const GSI_key =
    "32181816134-eia7uqf63e5eco0oieccldum6rvm3tr4.apps.googleusercontent.com";

// EmailJS https://www.emailjs.com/
export const message_key = {
    service: "service_yqpp22e",
    template: "template_onfrbuh",
    api: "LGhJfgjipb9WfTI1i",
};

// For Local
// export const GSI_key = "32181816134-2sics45tuk9t6inm80ovkb6iulcql2jg.apps.googleusercontent.com"
export const breakpoints = {
    xs: 0,
    xm: 400,
    sm: 600,
    md: 820,
    lg: 1040,
    xl: 1500,
};
